import { render, staticRenderFns } from "./RegistroNew.vue?vue&type=template&id=b1d487ba&scoped=true&"
import script from "./RegistroNew.vue?vue&type=script&lang=js&"
export * from "./RegistroNew.vue?vue&type=script&lang=js&"
import style0 from "./RegistroNew.vue?vue&type=style&index=0&id=b1d487ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d487ba",
  null
  
)

export default component.exports